import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link, createFileRoute } from "@tanstack/react-router";
import { Building2, Users } from "lucide-react";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/admin/_guard/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="p-4 space-y-6">
      <div className="mb-2">
        <Link to="/" className="inline-block">
          <Button variant="outline">Inicio</Button>
        </Link>
      </div>
      <div>
        <h3 className="text-lg font-medium">Panel administrador</h3>
        <p className="text-sm text-muted-foreground">
          Controla y gestiona todo tu sistema desde aquí
        </p>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <Link to="/admin/users">
          <Card className="hover:bg-accent transition-colors">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Users className="h-5 w-5" />
                Usuarios
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Gestiona cuentas, accesos y permisos
              </p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/companies">
          <Card className="hover:bg-accent transition-colors">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Building2 className="h-5 w-5" />
                Empresas
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Administra empresas y sus miembros
              </p>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
